import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {serviceMotionList} from '../../utils/serviceMotionList';

import FeatureCardBox from '../common/FeatureCardBox';

import {ReactComponent as AddQuestionImg} from '../../assets/chat04/add-question.svg';
import {ReactComponent as AlgorithmImg} from '../../assets/chat04/algorithm.svg';
import {ReactComponent as ReQuestionImg} from '../../assets/chat04/re-question.svg';

export default function Chat04() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');

    const dataMap = [
        { 
            type: 're-question',
            title: '재질문',
            subTitle: '모호한 질문은 선택지를 통해 정확하게 만들어요',
            Image: ReQuestionImg
        },
        { 
            type: 'add-question',
            title: '추가 질문',
            subTitle: '연관되는 선택지를 통해 질문을 이어가요',
            Image: AddQuestionImg
        }
    ];

    return (
        <FeatureCardBox
            type='algorithm'
            IconImage={AlgorithmImg}
            keyword='질문 알고리즘'
            title={mobileSmall ? <>정확한 답변을 위한<br />프로세스를 제공해요!</> : '정확한 답변을 위한 프로세스를 제공해요!'}
            featureCardList={dataMap}
            titleMotion={serviceMotionList.titleMotion}
            cardMotion={serviceMotionList.cardMotion}
        />
    );
}
